import React, { useCallback } from 'react';
import Select from 'apollo-react/components/Select';
import MenuItem from 'apollo-react/components/MenuItem';
import FieldWrapper from '../../fields/FieldWrapper';

const SelectFieldInput = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  helperText,
  showError,
  disabled,
  required,
  columnStyle,
  options,
}) => {
  const handleChange = useCallback(
    (e) => {
      if (onChange) onChange(e);
    },
    [onChange]
  );

  return (
    <FieldWrapper style={columnStyle}>
      <Select
        id={id}
        name={id}
        label={label}
        placeholder={placeholder || 'Select an option'}
        value={value || ''}
        onChange={handleChange}
        onBlur={onBlur}
        helperText={helperText}
        error={showError}
        disabled={disabled}
        required={required}
        fullWidth
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FieldWrapper>
  );
};

export default SelectFieldInput;
